<div class="flex-container flex-col base-gap-3r">
  <div class="flex-container flex-col menu">
    <htc-accordion [accordionSections]="sectionKeys">
      <ng-template #sect let-section>
        @for (item of flagSectionsMap.get(section); track item) {
          <p>
            <label
              [for]="'item_' + section + '_' + item"
              class="flex-container flex-align-center base-gap-1r">
              <input
                [id]="'item_' + section + '_' + item"
                type="checkbox"
                [name]="'item_' + section + '_' + item"
                value=""
                [ngModel]="flags.get(item)"
                (click)="onCheckboxClicked(item)" />{{ item }}
              @if (flagLabels[item]) {
                <i>{{ '(' + flagLabels[item] + ')' }}</i>
              }
            </label>
          </p>
        }
      </ng-template>
    </htc-accordion>
  </div>
  <div class="grade-selection">
    <div>Select Grade (Requires Reload)</div>
    <select name="Grade" id="grade" (change)="onGradeChange($event)">
      <option selected value="">None</option>
      @for (grade of gradeOptions; track grade; let i = $index) {
        <option
          [ngValue]="grade.value"
          [value]="grade.value"
          [selected]="featureFlagService.isFlagEnabled(grade.value)">
          {{ grade.label }}
        </option>
      }
    </select>
  </div>
  <div class="flex-container base-gap-1r">
    @if ((featureFlagService.hasOverride$ | async) ?? false) {
      <button class="btn btn-danger" (click)="clearOverrides()">
        Clear Overrides
      </button>
    }
  </div>
</div>
